import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';

import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';

Sentry.init({
  dsn: 'https://cf763c9b3990167d2f9f284537ecc713@o4511585764114432.ingest.de.sentry.io/4511585811497040',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
  ],
  tracesSampleRate: environment.production ? 0.2 : 1.0,
  tracePropagationTargets: ['localhost', /^https:\/\/.*\.capx\.co\.za/],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
